/**
 * Token Storage Utility
 * Manages storage and retrieval of authentication tokens in localStorage
 */

export const tokenStorage = {
    setPodSession: (sessionData) => {
        sessionStorage.setItem('pod_session', JSON.stringify(sessionData));
        // Still dispatch an event so other hooks (like useUserData) know to update
        window.dispatchEvent(new CustomEvent('userProfileStored'));
    },

    getPodSession: () => {
        const session = sessionStorage.getItem('pod_session');
        return session ? JSON.parse(session) : null;
    },

    clearTokens: () => {
        sessionStorage.removeItem('pod_session');
    },

    isTokenExpired: () => {
        return false;
    }
};
